<!--end candidate grid view -->
<div class="container-fluid">
    <div class="row">
        <div class="overflow-auto table-w">
            <table class="table bg-white" cellspacing="0" width="100%">
                <thead class="bg-table-header1">
                    <tr>
                        <th>Sr. No.</th>
                        <th>Action</th>
                        <th>Action Detail</th>
                        <th>Created/Performed/Updated By</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>IP</th>
                        <th>Source</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let list of logs; let i = index">
                        <td>{{i+1}}</td>
                        <td>{{list.txn_action}}</td>
                        <td>{{list.log_desc}} {{list.txn_detail}} By - {{list.updated_by}}</td>
                        <td>{{list.updated_by}}</td>
                        <td>{{list.txn_date}}</td>
                        <td>{{list.txn_time}}</td>
                        <td>{{list.ip}}</td>
                        <td>{{list.source}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<!--end table view -->